import _ from 'lodash';
import React from 'react';
import { MdSave, MdVpnKey } from 'react-icons/md';
import Crud from '~/components/crud';
import confirm from '~/components/confirm';
import { formats } from '~/helper';
import { CompanyForm, CompanySchema } from '~/views/companies/form';
import { Container } from '~/views/companies/styles';
import CellStatus from '~/components/datatable/cell-status';
import useCompanies from '~/view-data/use-companies';

const columns = [
  {
    name: '# CNPJ/Número de registro',
    selector: 'identify',
    cell: (row) => {
      let text = formats.cnpj(_.get(row, 'identify')) || _.get(row, 'identify') || '';
      return (
        <CellStatus title={text} color={row.active ? '#53d449' : '#e6467f'}>
          <strong>{text}</strong>
        </CellStatus>
      );
    }
  },
  {
    name: 'Razão social',
    selector: 'name'
  },
  {
    name: 'Nome fantasia',
    selector: 'tradeName'
  },
  {
    name: 'É imprensa?',
    selector: 'isPress',
    format: (row) => row.isPress ? 'Sim' : 'Não'
  },
  {
    name: 'Cadastrado em',
    selector: 'createdAt',
    hide: 'md',
    width: '140px',
    format: (row) => formats.dateTimeZone(_.get(row, 'createdAt'), 'dd/MM/yyyy HH:mm')
  },
];

function Companies({ acls }) {
  const canWrite = acls.includes('W');
  const { state, actions } = useCompanies();

   async function handlePasswordReset(data, options) {
    const result = await confirm.show({
      title: 'Atenção',
      text: `Deseja realmente redefinir a senha do usuário desta empresa?`,
    });

    if (result) {
      actions.resetPassword(data, options);
    }
  };

  return (
    <Container>
      <Crud
        columns={columns}
        emptyText='Nenhuma empresa encontrada'
        formTitle={(data) => (_.get(data, 'id')) ? `Empresa #${data.id}` : `Nova empresa`}
        data={state.data}
        hideAdd={!canWrite}
        tableLoading={state.loading}
        formLoading={state.formLoading}
        onChangePage={actions.pageChange}
        onRowClicked={actions.load}
        formOptions={{
          validationSchema: CompanySchema,
          initialValues: state.model,
          initialTouched: { identify: true },
        }}
        renderForm={(args) => <CompanyForm {...args} onSearchCnpj={actions.searchCnpj} previewMode={!canWrite} />}
        actions={[
          {
            label: 'Redefinir Senha',
            icon: MdVpnKey,
            isDisabled: ({ isValid }) => !_.get(state, 'model.id') || !canWrite,
            action: handlePasswordReset,
          },
          {
            label: 'Salvar',
            icon: MdSave,
            isSubmit: true,
            isDisabled: ({ isValid }) => !isValid || !canWrite,
            action: actions.createOrUpdate,
          },
        ]}
      />
    </Container>
  );
}

export default Companies;
